import { h, Component, Prop, Host } from '@stencil/core';
import { Smartphone } from '../../utils/Smartphone.js';

type DeviceObject = {
    text: string;
    value: string;
}

@Component({
    shadow: true,
    styleUrl: 'igws-device-specific.less',
    tag: 'igws-device-specific',
})
export class DeviceSpecificComponent {
    devices!: DeviceObject[];
    show: string[] = [];
    smartphone: Smartphone;
    type!: string;
    CATEGORY!: string;
    isMobile!: boolean;
    isTablet!: boolean;

    /**
     * CMS edit mode
     */
    @Prop() editMode!: boolean;

    /**
     * List of devices
     */
    @Prop() options!: string;

    componentWillLoad() {
        this.availableDevices();
    }

    category() {
        const deviceCategory = window.PSC.Cookie.get('mobile_device');
        return deviceCategory === 'false' ? 'desktop' : deviceCategory;
    }

    availableDevices() {
        this.devices = Object.values(JSON.parse(this.options));
        this.smartphone = new Smartphone();
        this.type = this.smartphone.type();
        this.CATEGORY = this.category();
        this.isMobile = this.CATEGORY === 'mobile';
        this.isTablet = this.CATEGORY === 'tablet';

        if (this.devices.some(device => device.value === this.type)) {
            this.show.push(this.type);
        } else {
            this.show.push('default');
        }

        if (this.smartphone.isIOS() && this.devices.some(device => device.value === 'ios')) {
            this.show.push('ios');
        }

        if (this.isMobile && this.devices.some(device => device.value === 'mobile')) {
            this.show.push('mobile');
        }

        if (this.isTablet && this.devices.some(device => device.value === 'tablet')) {
            this.show.push('tablet');
        }
    }

    render() {
        if (this.editMode) {
            return <Host>
                {this.devices.map(device => 
                    <div class="content">
                        <span class="label">{device.text}</span>
                        <slot name={device.value} />
                    </div>
                )}
            </Host>
        } 
        return <Host>
            {this.show.map(id => 
                <div class="content">
                    <slot name={id} />
                </div>
            )}
        </Host>        
    }
}